import {
    authCheckAccessToken,
    BaseClientConfig,
    UserAuthEvents,
} from '@news-mono/web-common'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import {
    BeginLoadingEvent,
    EndLoadingEvent,
} from 'react-ssr-data-loader/dist/cjs/events'
import { Logger } from 'typescript-log'

interface AuthenticationHandlerProps {
    logger: Logger
    config: BaseClientConfig
    onEvent: (
        authEvent: UserAuthEvents | BeginLoadingEvent | EndLoadingEvent,
    ) => void
}

export const AuthenticationHandler: React.FC<AuthenticationHandlerProps> = ({
    logger,
    onEvent,
}) => {
    const dispatch = useDispatch()
    const location = useLocation()

    useEffect(() => {
        dispatch(authCheckAccessToken({ onEvent, logger, invokation: 'auto' }))
    }, [location.pathname, onEvent, logger, dispatch])

    return null
}
